<template>
    <div>
        <FilterBar
            cookieName="ProductsFilterOptionsVue"
            :mainFilters="['ProductYearSelector', 'ProductFormatSelector']"
            :secondaryFilters="[]"
            filterBarType="products"
            @change="filtersChanged">
        </FilterBar>

        <div class="content--inner">
            <b-table
                :fields="fields"
                :items="items"
                :class="['product-report-table gk-table gk-table--responsive gk-table--striped gk-table--headed']"
                :busy="loading"
                :key="tableKey"
                show-empty
                table-busy
            >
                <template #empty="">
                    <span class="empty-table-text" v-translate>No products found.</span>
                </template>

                <template #cell()="data">
                    <div v-if="['description', 'group'].includes(data.field.key)">
                        {{ data.value }}
                    </div>
                    <div v-else>
                        <span v-if="format === 'quantity'">
                            {{ data.value > 0 ? data.value : '' }}
                        </span>
                        <span v-else>
                            €&nbsp;{{ Number(data.value).toFixed(2).replace(/\.?0+$/, '') }}
                        </span>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportsService from '@/store/services/reports.service';
import FilterBar from "@/components/list_filters/FilterBar";

export default {
    name: "ProductTable",
    components: {FilterBar},
    data() {
        return {
            fields: [
                { key: "description", label: this.$gettext("Description"), tdClass: "col-description coldesc" },
                { key: "group", label: this.$gettext("Product group"), tdClass: "col-group coldesc tablecol-sm" },
                { key: "q1", label: this.$gettext("Q1"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q2", label: this.$gettext("Q2"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q3", label: this.$gettext("Q3"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "q4", label: this.$gettext("Q4"), tdClass: "tablecol-sm text-right", thClass: "text-right" },
                { key: "total", label: this.$gettext("Year"), tdClass: "tablecol-sm text-right", thClass: "text-right" }
            ],
            items: [],
            productGroups: [],
            loading: true,
            tableKey: 0,
            format: "eur",
            filters: {}
        }
    },
    computed: {
        ...mapGetters({ 
            getCompanyId: 'main/getCompanyId'
        }),
    },
    methods: {
        filtersChanged(filters) {
            this.loading = true;
            this.filters = filters;
            this.filters.company_profile = this.getCompanyId;
            this.getProducts(filters);
        },
        getProducts(filters) {
            let year = filters.product_year;
            if (!year)
                year = new Date().getFullYear();

            const params = {
                product_year: year,
                ...filters
            }
            this.format = filters.product_format || 'eur';

            ReportsService.getProductsServicesData(params).then((response) => {
                let rows = response.data.slice(1);
                this.items = [];

                for (let i = 0; i < rows.length; i++) {
                    this.items.push({
                        "description": rows[i][0],
                        "group": rows[i][1],
                        "q1": rows[i][2],
                        "q2": rows[i][3],
                        "q3": rows[i][4],
                        "q4": rows[i][5],
                        "total": rows[i][6]
                    })
                }

                this.loading = false;
            })
        },
        downloadCSV() { // Used in Products.vue
            ReportsService.downloadProductsAndServicesCSV(this.filters).then(() => {
                this.$store.commit('setAlert', {
                    title: this.$gettext('Report Download'),
                    text: this.$gettext('Your download is being prepared, check your downloads page to download the file.'),
                    variant: 'info',
                    duration: 4
                })
                if (this.$route.name === "ControlPanelInvoices") {
                    this.$router.push({ name: 'ControlPanelFiles' })
                } else {
                    this.$router.push({ name: 'Files' })
                }
            }).catch(() => {
                this.$store.commit('setAlert', {
                    title: this.$gettext('Report Download Error'),
                    text: this.$gettext('An error occurred while trying to download the report. Please try again later.'),
                    variant: 'danger',
                    duration: 4
                })
            })
        }
    }
}
</script>

<style lang="scss">
.product-report-table  {
    .col-description { font-size: 16px; }
    .col-group { font-size: 14px; }
    &.gk-table--headed {
      thead {
        background: none;
        text-transform: none;
        color: $colorTextBase;
        th {
          font-size: 1rem;
          padding: 1rem 0.75rem;
          font-weight: normal;
          font-family: DINNextLTPro-Medium, sans-serif;
        }
      }
      tbody {
        tr {
            cursor: initial;
        }
      }
    }
}
</style>